export function parseOpcoes(opcoes) {
    if (!opcoes) return [];

    return String(opcoes)
        .split(';')
        .map(opcao => opcao.trim())
        .filter(Boolean)
        .map(opcao => {
            const partes = opcao.split('=');

            if (partes.length === 2) {
                return {
                    value: partes[0].trim(),
                    label: partes[1].trim()
                };
            }

            return {
                value: opcao,
                label: opcao
            };
        });
}

export function parseListaValores(valor) {
    if (!valor) return [];

    return String(valor)
        .split(';')
        .map(v => v.trim())
        .filter(Boolean);
}

export function itemPrecisaInformacao(item, opcoesCkObsPadrao = null) {
    if (!item) return false;

    if (item.ckinformacoes === 'S') return true;

    const opcoesCkObs = parseListaValores(item.opcoes_ckobs || opcoesCkObsPadrao);
    if (!opcoesCkObs.length) return false;

    const respostas = parseListaValores(item.resposta_opcoes);

    return respostas.some(resposta => opcoesCkObs.includes(resposta));
}